import AmericanCompanyContext from "components/company/v3/context/AmericanCompanyContext";
import BrazilianCompanyContext from "components/company/v3/context/BrazilianCompanyContext";
import BrazilianRealEstateFundContext from "components/company/v3/context/BrazilianRealEstateFundContext";
import LocaleContext from "components/i18n/LocaleContext";
import type { IIssuerByTickerSymbolQuery } from "lib/queries/__generated__/IssuerByTickerSymbolQuery.generated";
import type { ReactNode } from "react";

interface RootCompanyProxyProps {
  issuer: NonNullable<IIssuerByTickerSymbolQuery["issuerByTickerSymbol"]>;
  children: ReactNode;
}
export default function RootCompanyProxy({ issuer, children }: RootCompanyProxyProps) {
  if (issuer.__typename === "AmericanCompanyIssuer") {
    return (
      <LocaleContext.Provider value="USA">
        <AmericanCompanyContext.Provider value={issuer}>{children}</AmericanCompanyContext.Provider>
      </LocaleContext.Provider>
    );
  }
  if (issuer.__typename === "BrazilianCompanyIssuer") {
    return (
      <LocaleContext.Provider value="BRA">
        <BrazilianCompanyContext.Provider value={issuer}>{children}</BrazilianCompanyContext.Provider>
      </LocaleContext.Provider>
    );
  }
  if (issuer.__typename === "BrazilianRealEstateFund") {
    return (
      <LocaleContext.Provider value="BRA">
        <BrazilianRealEstateFundContext.Provider value={issuer}>{children}</BrazilianRealEstateFundContext.Provider>
      </LocaleContext.Provider>
    );
  }

  return null;
}
